import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { Item, SolarCalcPage } from '@/constants/solar-calculator';
import NextImage from '@/components/NextImage';

export default function Step4({ calObj, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const [checked, setChecked] = useState(calObj?.check4 || '');
    const items: Item[] = [
        {
            webp: require('@publicLocal/solar-calculator/pc/4_1.webp'),
            img: require('@publicLocal/solar-calculator/pc/4_1.jpg'),
            text: t('step4_text1'),
            icon: (
                <svg className="item-icon" xmlns="http://www.w3.org/2000/svg" width=".18rem" height=".16rem" viewBox="0 0 18 16" fill="none">
                    <path
                        d="M9.41464 0.806099C10.65 0.806099 11.6839 1.69282 11.9022 2.87822L16.0497 2.87792C16.9887 2.87792 17.7499 3.63854 17.7499 4.57682V14.1072C17.7499 15.0455 16.9887 15.8061 16.0497 15.8061H1.95023C1.01122 15.8061 0.25 15.0455 0.25 14.1072V4.57682C0.25 3.63854 1.01122 2.87792 1.95023 2.87792L6.09664 2.87813C6.31133 1.69961 7.34387 0.806099 8.58526 0.806099H9.41464ZM1.87918 3.72277C1.43964 3.72277 1.08333 4.07985 1.08333 4.52034V14.1752C1.08333 14.6157 1.43964 14.9728 1.87918 14.9728H16.1207C16.5603 14.9728 16.9166 14.6157 16.9166 14.1752V4.52034C16.9166 4.07985 16.5603 3.72277 16.1207 3.72277H1.87918ZM8.58329 10.3894V11.2228H4.41664V10.3894H8.58329ZM13.5833 9.13943V10.0208H10.3333V11.2228H9.41661V9.13943H13.5833ZM8.58329 8.72276V9.5561H4.41664V8.72276H8.58329ZM8.58329 7.47276V8.3061H4.41664V7.47276H8.58329ZM13.5833 7.47276V8.3061H9.41661V7.47276H13.5833ZM9.41499 1.63943H8.62419C7.93222 1.63943 7.3467 2.15403 7.15145 2.86276L7.1446 2.88943H10.8946L10.8905 2.87245C10.7051 2.18484 10.1531 1.67956 9.49451 1.64171L9.41499 1.63943Z"
                        fill="white"
                    />
                </svg>
            ),
        },
        {
            webp: require('@publicLocal/solar-calculator/pc/4_2.webp'),
            img: require('@publicLocal/solar-calculator/pc/4_2.jpg'),
            text: t('step4_text2'),
            icon: (
                <svg className="item-icon" xmlns="http://www.w3.org/2000/svg" width=".21rem" height=".21rem" viewBox="0 0 21 21" fill="none">
                    <path
                        d="M9.47198 8.22276L9.56705 5.44989C9.57879 5.38565 9.53622 5.32406 9.47198 5.31232C9.42564 5.30386 9.37869 5.32371 9.35248 5.36286L4.55906 12.5227C4.52273 12.5769 4.53727 12.6504 4.59154 12.6867C4.611 12.6997 4.63389 12.7067 4.65732 12.7067H7.6768L6.80326 18.0765C6.79277 18.141 6.83652 18.2018 6.90098 18.2122C6.9475 18.2198 6.99407 18.199 7.0195 18.1594L10.9656 12.005"
                        stroke="white"
                        strokeWidth="0.833331"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.8927 1.81743L7.37542 11.3465C7.33807 11.4011 7.35206 11.4757 7.40667 11.513C7.42659 11.5266 7.45016 11.5339 7.47429 11.5339H11.4394L10.0257 18.6865C10.0129 18.7514 10.0551 18.8144 10.12 18.8272C10.1671 18.8366 10.2153 18.8168 10.2423 18.777L16.7035 9.2584C16.7407 9.20366 16.7264 9.12916 16.6717 9.092C16.6518 9.07853 16.6284 9.07133 16.6044 9.07133H12.7696L14.1093 1.90707C14.1214 1.84204 14.0786 1.77947 14.0136 1.7673C13.9669 1.75858 13.9195 1.77824 13.8927 1.81743Z"
                        stroke="white"
                        strokeWidth="0.833331"
                    />
                </svg>
            ),
        },
    ];

    const handleCheck = (key: number) => {
        setChecked(key === checked ? '' : key);
        callBack({ ...calObj, currentStep: key === checked ? 3 : 4, check4: key === checked ? '' : key });
    };

    const handleBack = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step3, currentStep: 3, check4: undefined }, true);
    };

    const handleNext = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step5 }, true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process4',
            step: 'Type',
            product_name: 'EcoFlow Solar Panel',
            button_name: 'Next',
            option_name: items?.find((item: Item) => item.key === checked)?.text,
        });
    };

    return (
        <div className={`step4 ${css.step4}`}>
            <p className="step4-title title">{t('step4_title')}</p>
            <ul className="step4-box">
                {items?.map((item: any, k: number) => (
                    <li className="step4-item" key={item?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                            {item?.icon}
                            {checked === k && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked width=".3rem" height=".3rem" className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{item?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="fix-footer">
                <button className="btn-back" onClick={handleBack}>
                    {t('common_back')}
                </button>
                <button className="btn-next" disabled={!checked && checked !== 0} onClick={handleNext}>
                    {t('common_next')}
                </button>
            </div>
        </div>
    );
}
